import { render, staticRenderFns } from "./ColumnInputDesc.vue?vue&type=template&id=c6fa3f0e"
import script from "./ColumnInputDesc.vue?vue&type=script&lang=js"
export * from "./ColumnInputDesc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports